import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp } from "../../motion";

const Reveal = ({
  children,
  className = "",
  as = "div",
  delay = 0,
  variants = fadeUp,
  once = true,
  amount = 0.18,
  ...rest
}) => {
  const reduce = useReducedMotion();
  const Component = motion[as] || motion.div;

  if (reduce) {
    const Tag = as;
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <Component
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount, margin: "0px 0px -8% 0px" }}
      transition={{ delay, ...(variants.show?.transition || {}) }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Reveal;
